export const productCategoryIntegers = [];
export const productCategoryFloats = [];
export const productCategoryIsoStrings = [];
export const productCategoryWhiteList = ['id', 'name'];
export const productCategoryOptimisticList = [...productCategoryWhiteList];
